import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const ListViewComponent = React.lazy(() => import("../Components/RootComponents/ListViewComponent"));
const ListViewPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ListViewComponent />
      </Suspense>
    </Fragment>
  );
};

export default ListViewPage;
